import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Button,
} from "@mui/material";

import WarningIcon from "@mui/icons-material/Warning";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import socketService from "socket/newsocketService";
import { toast } from "react-toastify";

const SOSAlertModal = ({ open, handleClose, data }) => {
  const [timeLeft, setTimeLeft] = useState(120);
  console.log("SOSAlertModal Rendered with data:", data);

  useEffect(() => {
    if (!open) return;

    setTimeLeft(120);

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          handleClose();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [open, handleClose]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const handleViewMap = () => {
    const lat = data?.lat ?? data?.currentLat ?? data?.Latitude;
    const lng = data?.lng ?? data?.currentLong ?? data?.Longitude;

    if (lat && lng) {
      window.open(
        `https://www.google.com/maps?q=${lat},${lng}`,
        "_blank"
      );
    }
  };

  const ownerName = data?.ownerName || data?.user_Name || data?.fullName || data?.name || "Unknown";
  const phoneNumber = data?.user_Phone || data?.userPhone || data?.mobile || data?.userPhoneP || "N/A";
  const locationText =
    data?.location ||
    data?.address ||
    (data?.lat && data?.lng ? `${data.lat}, ${data.lng}` : "Location not available");
  const createdAt = data?.createdAt || data?.timestamp || data?.sentAt || new Date().toISOString();

  if (!data) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <Box
        sx={{
          backgroundColor: "#d32f2f",
          color: "#fff",
          padding: "12px 16px",
          fontWeight: "bold",
        }}
      >
        🚨 SOS ALERT
      </Box>

      <DialogContent sx={{ textAlign: "center", padding: 3 }}>
        <Box
          sx={{
            width: 100,
            height: 100,
            margin: "0 auto",
            borderRadius: "50%",
            backgroundColor: "#e53935",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontWeight: "bold",
            fontSize: 28,
            boxShadow: "0 0 0 8px rgba(229,57,53,0.2)",
          }}
        >
          SOS
        </Box>

        <Typography sx={{ mt: 2, fontWeight: 500 }}>
          Emergency SOS triggered!
        </Typography>

        <Box sx={{ mt: 3, textAlign: "left" }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <PersonIcon sx={{ mr: 1 }} />
            <Typography sx={{ fontSize: 16 }}>
              Owner: {ownerName}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <PhoneIcon sx={{ mr: 1 }} />
            <Typography sx={{ fontSize: 16 }}>
              {phoneNumber}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <LocationOnIcon sx={{ mr: 1 }} />
            <Typography sx={{ fontSize: 16 }}>
              {locationText}{" "}
              <span
                onClick={handleViewMap}
                style={{
                  color: "#1976d2",
                  cursor: "pointer",
                  marginLeft: 6,
                }}
              >
                View on Map
              </span>
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <AccessTimeIcon sx={{ mr: 1 }} />
            <Typography sx={{ fontSize: 16 }}>
              {new Date(createdAt).toLocaleString()}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: 4,
          }}
        >
          <Box
            sx={{
              width: 70,
              height: 70,
              borderRadius: "50%",
              border: "6px solid #1976d2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
            }}
          >
            {formatTime(timeLeft)}
          </Box>

          <Button
            variant="contained"
            startIcon={<WarningIcon />}
            sx={{
              ml: 2,
              flex: 1,
              color: "#fff",
              backgroundColor: "#263238",
              "&:hover": { backgroundColor: "#37474f" },
            }}
            onClick={async () => {
              const payload = {
                alert_type: "SOS",
                alert_message: "Emergency SOS triggered",
                Latitude: Number(data?.currentLat || data?.lat),
                Longitude: Number(data?.currentLong || data?.lng),
                isRead: true,
                user_Img: data?.profile || "",
                user_Name: data?.ownerName || data?.vehicleNickname || "",
                user_Phone: data?.phone || data?.mobile,
                vehicleName: data?.vehicleNickname || data?.vehicleName || "",
                vehicleNumber: data?.licensePlate || "",
                timestamp: data?.createdAt,
                userId: data?.userId || "",
              };

              try {
                const result = await socketService.emitWithAck("sendalert", {
                  payload,
                  isBroadcast: false,
                });

                if (result?.success === false) {
                  throw new Error(result?.message || "Failed to dispatch security");
                }

                toast.info("Security dispatched");
                handleClose();
              } catch (error) {
                console.error("SOS dispatch failed:", error);
                toast.error(error?.message || "Failed to dispatch security");
              }
            }}
          >
            DISPATCH TO VIGILANTEYE
          </Button>
        </Box>

        <Button
          variant="outlined"
          startIcon={<PhoneIcon />}
          fullWidth
          sx={{
            mt: 2,
            color: "#1976d2",
            borderColor: "#1976d2",
          }}
          onClick={() => {
            if (data?.phone) {
              window.location.href = `tel:${data.phone}`;
            }
          }}
        >
          Call Owner
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default SOSAlertModal;
